import React, { useState } from 'react'

import {
  DepositTableContainerStyled,
  DepositTableStyled,
  DepositTableHeadStyled,
  DepositTableRowStyled,
  DepositTableRowHeadStyled,
  DepositTableRowBodyStyled,
  DepositTableColumnStyled,
  DepositTableIconStyled,
  DepositTableSubRowStyled,
  DepositTableSubRowColumnStyled,
  DepositTableBadgeStyled,
  DepositTableLegendStyled,
  DepositTableLegendItemStyled
} from './styles'
import { IconAccordionArrow } from '../../../assets/svg/index'
import { DepositTableProps, DepositLegendProps, AccordionItemProps, DepositTableValProps } from './types'
import StaticImage from './../../atoms/ImageStatic'
import DownloadBadge from './../../atoms/DownloadBadge'
import { scrollToSection } from './../../../common/helpers'
import { useResponsiveValue } from '@theme-ui/match-media'

const DepositTable: React.FC<DepositTableProps> = ({ data, id }) => {
  const { list, legend } = data

  const isTablet = useResponsiveValue([false, true, true, true], {
    defaultIndex: 0
  })

  const AccordionItem: React.FC<AccordionItemProps> = ({ data, symbolCode }) => {
    const [isOpen, setIsOpen] = useState(false)
    const handleClick = (arg: number) => {
      setIsOpen(!isOpen)
      if (!isTablet) {
        setTimeout(function () {
          scrollToSection(`accordion-deposit-${id}-${arg}`, 600, 100, -120)
        }, 100)
      }
    }

    return (
      <DepositTableRowStyled>
        <DepositTableRowHeadStyled
          name={`accordion-deposit-${id}-${symbolCode}`}
          isOpened={isOpen}
          onClick={() => handleClick(symbolCode)}
          aria-expanded={isOpen}
        >
          <DepositTableIconStyled>
            <IconAccordionArrow />
          </DepositTableIconStyled>
          {Object.values(data).map(function (value: DepositTableValProps, index) {
            return (
              <DepositTableColumnStyled key={`${value}-${index}`}>
                {value.image ? <StaticImage image={value.image} /> : value.title}
                {value.download && (
                  <DepositTableBadgeStyled>
                    <DownloadBadge url={value.download.url} />
                  </DepositTableBadgeStyled>
                )}
              </DepositTableColumnStyled>
            )
          })}
        </DepositTableRowHeadStyled>
        <DepositTableRowBodyStyled>
          {Object.entries(data)
            .slice(1)
            .map((item, index) => {
              return (
                <DepositTableSubRowStyled key={`${item[1]}-${index}`}>
                  <DepositTableSubRowColumnStyled>{item[0]}</DepositTableSubRowColumnStyled>
                  <DepositTableSubRowColumnStyled>{item[1].title}</DepositTableSubRowColumnStyled>
                </DepositTableSubRowStyled>
              )
            })}
        </DepositTableRowBodyStyled>
      </DepositTableRowStyled>
    )
  }

  return (
    <DepositTableContainerStyled>
      <DepositTableStyled>
        <DepositTableHeadStyled>
          <DepositTableIconStyled></DepositTableIconStyled>
          {Object.keys(list[0]).map(function (key, index) {
            return <DepositTableColumnStyled key={`${key}-${index}`}>{key}</DepositTableColumnStyled>
          })}
        </DepositTableHeadStyled>
        {list.map((el: AccordionItemProps, index: number) => {
          return <AccordionItem data={el} symbolCode={index} />
        })}
      </DepositTableStyled>
      {legend && (
        <DepositTableLegendStyled>
          {legend.map((el: DepositLegendProps) => (
            <DepositTableLegendItemStyled key={el.key}>{el.title}</DepositTableLegendItemStyled>
          ))}
        </DepositTableLegendStyled>
      )}
    </DepositTableContainerStyled>
  )
}

export default DepositTable
